// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"idt-colorattributedropdown_dropdown__3bdde"};